/**
 * Inbox IA v2 — 「通知」primary owner 底下的 secondary（FE-IA-V2-03）。
 * Canonical：訊息 / 通知。後端 IM 與 Notification 仍分離；不造假 unified API。
 */

export const INBOX_IA_SECONDARY = Object.freeze([
  {
    id: 'messages',
    to: '/messages',
    labelKey: 'travel.nav.messages',
    testId: 'inbox-tab-messages',
    section: 'messages',
  },
  {
    id: 'notifications',
    to: '/notifications',
    labelKey: 'travel.nav.notifications',
    testId: 'inbox-tab-notifications',
    section: 'notifications',
  },
]);

export const INBOX_IA_NOTIFICATION_SUBTYPES = Object.freeze([
  {
    id: 'social',
    to: '/notifications',
    labelKey: 'travel.nav.notifications',
    testId: 'notification-tab-social',
    active: 'social',
  },
  {
    id: 'groupTrip',
    to: '/group-trip-notices',
    labelKey: 'travel.nav.notices',
    testId: 'notification-tab-group-trip',
    active: 'groupTrip',
  },
]);

/**
 * OLD_ROUTE → IA_V2_OWNER → CANONICAL_DESTINATION → COMPATIBILITY_ACTION
 */
export const INBOX_IA_ROUTE_COMPATIBILITY = Object.freeze([
  {
    oldRoute: '/notifications',
    owner: 'notifications',
    destination: '/notifications',
    action: 'KEEP_AS_PRIMARY_DEFAULT',
  },
  {
    oldRoute: '/messages',
    owner: 'notifications',
    destination: '/messages',
    action: 'KEEP_MESSAGES_SECONDARY',
  },
  {
    oldRoute: '/messages/:conversationId',
    owner: 'notifications',
    destination: '/messages/:conversationId',
    action: 'KEEP_CONVERSATION_DETAIL',
  },
  {
    oldRoute: '/group-trip-notices',
    owner: 'notifications',
    destination: '/group-trip-notices',
    action: 'KEEP_GT_NOTICE_SUBTYPE',
  },
  {
    oldRoute: '/announcements',
    owner: 'notifications',
    destination: '/announcements',
    action: 'KEEP_RELATED_SYSTEM',
  },
  {
    oldRoute: '/site-mail',
    owner: 'notifications',
    destination: '/site-mail',
    action: 'KEEP_RELATED_SYSTEM',
  },
]);

/** Header bell 與 primary「通知」同一 owner／destination（shortcut，非第二套 center）。 */
export const INBOX_HEADER_BELL = Object.freeze({
  to: '/notifications',
  role: 'PRIMARY_OWNER_SHORTCUT',
  owner: 'notifications',
});

export function resolveInboxSection(pathname) {
  const path = String(pathname || '');
  if (path === '/messages' || path.startsWith('/messages/')) return 'messages';
  if (path === '/group-trip-notices' || path.startsWith('/group-trip-notices/')) return 'notifications';
  if (path === '/notifications' || path.startsWith('/notifications/')) return 'notifications';
  if (path === '/announcements' || path.startsWith('/announcements/')) return 'notifications';
  if (path === '/site-mail' || path.startsWith('/site-mail/')) return 'notifications';
  return null;
}

export function resolveNotificationSubtype(pathname, activeHint) {
  if (activeHint === 'social' || activeHint === 'groupTrip') return activeHint;
  const path = String(pathname || '');
  if (path === '/group-trip-notices' || path.startsWith('/group-trip-notices/')) return 'groupTrip';
  return 'social';
}
